import React from "react";
import { LangLink as Link } from "@/components/LangLink";
import { ArrowRight } from "lucide-react";
import { useT } from "@/hooks/useT";

/**
 * Dark premium CTA — "Më pak procese manuale. Më shumë kontroll."
 */
export default function DarkCTA() {
  const t = useT();
  return (
    <section className="relative overflow-hidden bg-[#0F172A] text-white grain-dark" data-testid="dark-cta">
      {/* Ambient warm glow */}
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[560px] w-[1100px] -translate-x-1/2 bg-[radial-gradient(closest-side,rgba(255,122,0,0.22),transparent)] blur-3xl" aria-hidden />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" aria-hidden />
      <div className="absolute inset-0 bg-dot-dark opacity-25 mask-fade-y" aria-hidden />

      <div className="container-tight relative py-24 md:py-32">
        <div className="mx-auto max-w-4xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/70">
            <span className="h-1.5 w-1.5 rounded-full bg-[#FF7A00] pulse-soft" />
            {t("Operacione, të thjeshtuara", "Operations, simplified")}
          </span>

          <h2
            className="mt-7 font-display font-extrabold tracking-[-0.045em] text-white"
            style={{ fontSize: "clamp(2.25rem, 1.3rem + 3.8vw, 4.75rem)", lineHeight: 1.02 }}
          >
            {t("Më pak procese manuale.", "Less manual work.")}<br />
            <span className="bg-gradient-to-r from-white via-white to-[#FF7A00] bg-clip-text text-transparent">
              {t("Më shumë kontroll.", "More control.")}
            </span>
          </h2>

          <p className="mx-auto mt-7 max-w-xl text-[16px] leading-[1.75] text-white/60">
            {t(
              "Rezervimet, kanalet, dhomat dhe faturimi — të gjitha të lidhura në një sistem që punon për hotelin tuaj, jo kundër tij.",
              "Reservations, channels, rooms and billing — all wired into one system that works for your hotel, not against it."
            )}
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/demo"
              data-testid="dark-cta-demo"
              className="group inline-flex items-center gap-2 rounded-full bg-[#FF7A00] px-7 py-3.5 text-[13.5px] font-bold uppercase tracking-[0.14em] text-white shadow-[0_14px_34px_-10px_rgba(255,122,0,0.6)] transition-all hover:bg-[#EA580C]"
            >
              {t("Kërko Demo", "Request Demo")}
              <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
            </Link>
            <Link
              to="/kontakt"
              data-testid="dark-cta-contact"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/[0.04] px-7 py-3.5 text-[13.5px] font-bold uppercase tracking-[0.14em] text-white/90 backdrop-blur-sm transition-all hover:border-white/35 hover:bg-white/[0.10] hover:text-white"
            >
              {t("Na Kontaktoni", "Contact us")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
